import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import objectPath from "object-path";
import { toAbsoluteUrl } from "../../../_helpers";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { Topbar } from "./Topbar";
import { HeaderMenuWrapper } from "./header-menu/HeaderMenuWrapper";

export function Header() {
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      headerClasses: uiService.getClasses("header", true),
      headerAttributes: uiService.getAttributes("header"),
      headerContainerClasses: uiService.getClasses("header_container", true),
      menuHeaderDisplay: objectPath.get(
        uiService.config,
        "header.menu.self.display"
      )
    };
  }, [uiService]);

  return (
    <>
      {/*begin::Header*/}
      <div
        className={`header ${layoutProps.headerClasses}`}
        id="kt_header"
        {...layoutProps.headerAttributes}
      >
        {/*begin::Container*/}
        <div
          className={` ${layoutProps.headerContainerClasses} d-flex align-items-stretch justify-content-between`}
          style={{
            height: "76px",
            background: "white",
            boxShadow: "3px 3px transparent, -0em 0 0.4em grey"
          }}
        >
          {/* begin::Left */}
          <div className="d-flex align-items-stretch mr-3">
            {/* begin::Header Logo */}
            <div
              className="header-logo"
              style={{
                width: "210px",
                marginLeft: "26px",
                marginTop: "30px"
              }}
            >
              <img
                className="logo-default max-h-40px"
                alt="Logo"
                src={toAbsoluteUrl("/media/images/toggle_lnb_handler.svg")}
              />
            </div>
            {/* end::Header Logo */}
            <div
              // className="header-logo"
              style={{
                display: 'flex',
                alignItems: 'center',
                width: "400px",
                // marginTop: "20px"
              }}
            >
              <img
                className="logo-default"
                alt="Logo"
                src={toAbsoluteUrl("/media/logo_bizbee.svg")}
              /> <span
              style={{
                marginLeft: 16,
                fontSize: 28,
                fontWeight: 900,
              }}
              >메일 관리자</span>
            </div>

            {layoutProps.menuHeaderDisplay && <HeaderMenuWrapper />}
          </div>
          {/* end::Left */}
        </div>
        {/*end::Container*/}
      </div>
      {/*end::Header*/}
    </>
  );
}
